import { useSearchStore } from "./search";
import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { useTypesenseStore } from "@/stores/typesense";
import { defineStore } from "pinia";
import moment from "moment";

export const useDownloadStore = defineStore("download", {
  state: () => ({
    psuSummary: null as api.CheckPsuResponseBody | null,
    psuRequestMessage: null as String | null,
    pdRequestMessage: null as String | null,
    loading: false,
  }),
  actions: {
    async checkPsu() {
      this.psuSummary = null;
      this.psuSummary = await client.downloads.downloadsCheckPsu();
    },
    async requestPsu(serverParams: object) {
      this.loading = true;
      this.psuRequestMessage = null;
      this.psuRequestMessage = await client.downloads
        .downloadsRequest({
          requestRequestBody: { type: api.RequestRequestBodyTypeEnum.Psu },
        })
        .then(() => "PSU requested")
        .catch((error) => {
          if (error.response.status == 404) {
            return "No package status updates found";
          }
          return "Unexpected error";
        })
        .finally(() => {
          this.loading = false;
          // const typesenseStore = useTypesenseStore();
          // typesenseStore.fetchTypesense("secure-zone-downloads", serverParams);    
          var today_date_add_7days_unix= moment(new Date()).unix() - 604800 ;
          useTypesenseStore().fetchTypesense("secure-zone-downloads", {
            filter_by:
            "( type:=PSU)  || (status:=Ready && type:=PD ) || (status:=Completed  && type:=PD && reviewed_at:>=" +today_date_add_7days_unix +") && requester:="+ 
              useAuthenticationStore().profile_email,
            sort_by: "",
            q: "*",
            query_by: "", // can include more fields.
            page: 1,
            per_page: 20,
          });
          this.checkPsu();
        });
    },
    async requestPD(pkgUuid: string) {
      this.pdRequestMessage = null;
      this.pdRequestMessage = await client.downloads
        .downloadsRequest({
          requestRequestBody: {
            type: api.RequestRequestBodyTypeEnum.Pd,
            packageUuid: pkgUuid,
          },
        })
        .then(() => "PD requested")
        .catch(() => "Unexpected error");
    },
    async requestSCU() {
      this.pdRequestMessage = null;
      this.pdRequestMessage = await client.downloads
        .downloadsRequest({
          requestRequestBody: {
            type: api.RequestRequestBodyTypeEnum.Scu
          },
        })
        .then(() => "SCU requested")
        .catch(() => "Unexpected error")
        .finally(() => {
          useTypesenseStore().fetchTypesense("secure-zone-downloads", {
            filter_by:
            " type:=SCU && requester:=" + 
              useAuthenticationStore().profile_email,
            sort_by: "",
            q: "*",
            query_by: "", // can include more fields.
            page: 1,
            per_page: 20,
          });
               
        });;
    },
    async retrieveDownloads(uuid: string , user_type:string) {
      this.loading = true;
      // fetch(
      //   import.meta.env.VITE_SERVER_HOST + "/downloads/" + uuid + "/retrieve",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      client.downloads.downloadsRetrieveRaw({uuid})
        .then((res) => res.raw)
        .then((res) => {
          res.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const filename = res.headers
              .get("content-disposition")
              ?.split('"')[1];
            if (filename) {
              var a = document.createElement("a");
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              this.loading = false;
            } else {
              window.location.assign(url);
            }
          });
        })
        .finally(() => {
        
          var today_date_add_7days_unix= moment(new Date()).unix() - 604800 ;
          if(user_type == "admin"){

            useTypesenseStore().fetchTypesense("secure-zone-downloads", {
              filter_by:
              " type:=SCU && requester:=" + 
                useAuthenticationStore().profile_email,
              sort_by: "",
              q: "*",
              query_by: "", // can include more fields.
              page: 1,
              per_page: 20,
            });

          }else if(user_type =="not-admin"){
      
            useTypesenseStore().fetchTypesense("secure-zone-downloads", {
              filter_by: "(status:!=Pending && status:!=Generating) && requester:=" + useAuthenticationStore().profile_email,
              // "(status:=Generating && type:=PSU ) || (status:=Ready && type:=PSU ) || (status:=Completed  && type:=PSU) || (status:=Downloaded  && type:=PSU)  || (status:=Ready && type:=PD ) || (status:=Completed  && type:=PD && reviewed_at:>=" +today_date_add_7days_unix +") && requester:="+ 
              //   useAuthenticationStore().profile_email,
              sort_by: "",
              q: "*",
              query_by: "", // can include more fields.
              page: 1,
              per_page: 20,
            });

          }

        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    approve(uuid: string, serverParams: object) {
      this.loading = true;
      client.downloads
        .downloadsApprove({ uuid: uuid })
        .then(() => {
          const typesenseStore = useTypesenseStore();
          typesenseStore.fetchTypesense("secure-zone-downloads", serverParams);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    reject(uuid: string, note: string, serverParams: object) {
      this.loading = true;
      client.downloads
        .downloadsReject({
          uuid: uuid,
          rejectRequestBody: { note: note },
        })
        .then(() => {
          const typesenseStore = useTypesenseStore();
          typesenseStore.fetchTypesense("secure-zone-downloads", serverParams);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    cancel(uuid: string, note: string, serverParams: object) {
      this.loading = true;
      client.downloads
        .downloadsCancel({
          uuid: uuid,
          rejectRequestBody: { note: note },
        })
        .then(() => {
          const typesenseStore = useTypesenseStore();
          typesenseStore.fetchTypesense("secure-zone-downloads", serverParams);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
});
